export default "__VITE_ASSET___iNLAGnI__"